// Trio Sporting wireframes — minimal vanilla JS (mobile nav + tab toggles)
document.addEventListener('click', function (e) {
  // mobile nav
  var toggleBtn = e.target.closest('.nav-toggle');
  if (toggleBtn) {
    var nav = document.querySelector('.main-nav');
    var isOpen = nav?.classList.toggle('open');
    // [2026-08-02, final pre-delivery wave] aria-expanded was hardcoded "false" in the
    // markup and never updated on click — a real accessibility bug (screen readers always
    // reported the menu as collapsed, even while open). Sync it here with the actual state.
    toggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }
  // generic tab groups: [data-tab] buttons toggle [data-panel]
  var tabBtn = e.target.closest('[data-tab]');
  if (tabBtn) {
    var group = tabBtn.closest('[data-tabgroup]');
    if (group) {
      group.querySelectorAll('[data-tab]').forEach(b => b.classList.remove('active'));
      tabBtn.classList.add('active');
      var key = tabBtn.getAttribute('data-tab');
      group.querySelectorAll('[data-panel]').forEach(p => {
        p.style.display = (p.getAttribute('data-panel') === key) ? '' : 'none';
      });
    }
  }
});
